import React from "react";
import styled from "styled-components";
import { variables, colors, devices } from "./../../assets/styles/variables";

const H1_Text = styled.h1`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.h1Size};
    line-height: ${variables.h1Line};
    font-weight: ${variables.h1Weight};
    color: ${colors.h1};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileH1Size};
        line-height: ${variables.mobileH1Line};
        font-weight: ${variables.mobileH1Weight};
        br { display: none; }
    }
`;

export const H1 = ({...rest}) => <H1_Text {...rest} />;

const H2_Text = styled.h2`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.h2Size};
    line-height: ${variables.h2Line};
    font-weight: ${variables.h2Weight};
    color: ${colors.h2};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileH2Size};
        line-height: ${variables.mobileH2Line};
        font-weight: ${variables.mobileH2Weight};
        br { display: none; }
    }
`;

export const H2 = ({...rest}) => <H2_Text {...rest} />;

const H3_Text = styled.h3`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.h3Size};
    line-height: ${variables.h3Line};
    font-weight: ${variables.h3Weight};
    color: ${colors.h3};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileH3Size};
        line-height: ${variables.mobileH3Line};
        font-weight: ${variables.mobileH3Weight};
        br { display: none; }
    }
`;

export const H3 = ({...rest}) => <H3_Text {...rest} />;

const H4_Text = styled.h4`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.h4Size};
    line-height: ${variables.h4Line};
    font-weight: ${variables.h4Weight};
    color: ${colors.h4};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileH4Size};
        line-height: ${variables.mobileH4Line};
        font-weight: ${variables.mobileH4Weight};
        br { display: none; }
    }
`;

export const H4 = ({...rest}) => <H4_Text {...rest} />;

const P_Text = styled.p`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.textSize};
    line-height: ${variables.textLine};
    font-weight: ${variables.textWeight};
    color: ${colors.black};
    margin: ${variables.textMargin};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileTextSize};
        line-height: ${variables.mobileTextLine};
        font-weight: ${variables.mobileTextWeight};
        br { display: none; }
        margin: ${variables.mobileTextMargin};
    }
`;

export const P = ({...rest}) => <P_Text {...rest} />;

const SMALL_Text = styled.small`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.smallSize};
    line-height: ${variables.smallLine};
    font-weight: ${variables.smallWeight};
    color: ${colors.black};
    display: block;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileSmallSize};
        line-height: ${variables.mobileSmallLine};
        font-weight: ${variables.mobileSmallWeight};
    }
`;

export const SMALL = ({...rest}) => <SMALL_Text {...rest} />;

const BannerTitle_Text = styled.div`
    font-family: ${variables.fontFamilyPrimary};
    font-size: ${variables.bannerTitleSize};
    line-height: ${variables.bannerTitleLine};
    font-weight: ${variables.bannerTitleWeight};
    color: ${colors.white};
    width: 100%;
    @media (max-width: ${devices.sizeLaptop}) {
        font-size: ${variables.mobileBannerTitleSize};
        line-height: ${variables.mobileBannerTitleLine};
        font-weight: ${variables.mobileBannerTitleWeight};
        br { display: none; }
    }
`;
// The Wholesale network that outperforms. 
export const BannerTitle = ({...rest}) => <BannerTitle_Text {...rest} />;